<template>
    <div>
        <div class="lista-smge" v-if="!loading">

            <div style="text-align: right;">
                <el-button size="mini" plain>
                    Frequência coletiva
                </el-button>
            </div>
            <ul>
                <li>
                    <h3>Lista de chamada</h3>
                </li>
                <li 
                    v-for="(item, i) in alunos" 
                    :key="i" 
                    v-bind:class="{ aprovado: (item.flag == 1 ? true : false), reprovado: (item.flag == 2 ? true : false), divergente: (item.flag == 3 ? true : false) }"
                >
                   <div class="box-data list-alunos" @click="alteraFrequencia(i)" >
                        <h3>{{ item.nome }}</h3>
                        <span class="freq-sub-titulo">Dt. Nascimento: {{ $moment(item.data_nascimento).format('DD/MM/YYYY') }}</span>
                    </div>
                    <el-button @click="abreModalAlteraFrequencia(i)" slot="reference" title="Mais ações" type="primary" icon="el-icon-menu" size="mini" plain></el-button>
                </li>
            </ul>
            <el-row :gutter="10">
                <div class="u-text-right ">
                    <el-button type="primary" @click="notaCadastrada">SALVAR</el-button>
                </div>
            </el-row>
        </div>
        <el-dialog :close-on-click-modal="false" :title="`EDITAR FREQUÊNCIA - ${alunos[indexAlunoSelected] ? alunos[indexAlunoSelected].nome : ''}`" width="40%" :visible.sync="dialogEditarFrequencia" :show-close="false">
            <div v-if="dialogEditarFrequencia" style="margin-top: 20px;">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Horário</th>
                            <th class="u-text-center" colspan="3">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(horario, j) in horariosSelected" :key="j">                            
                            <td>{{ horario }}º horário</td>
                            <td style="width: 125px;">
                                <el-button @click="alunos[indexAlunoSelected].horarios[horario].v = 'p'"  v-bind:class="{ aprovado: (alunos[indexAlunoSelected].horarios[horario].v == 'p' ? true : false) }" :title="`Lançar presença no ${horario}º horário`" size="mini" style="width: 120px;" plain>
                                    Presença
                                </el-button>
                            </td>
                            <td style="width: 125px;">
                                <el-button @click="alunos[indexAlunoSelected].horarios[horario].v = 'f'" v-bind:class="{ reprovado: (alunos[indexAlunoSelected].horarios[horario].v == 'f' ? true : false) }" :title="`Lançar presença no ${horario}º horário`" size="mini" style="width: 120px;" plain>
                                    Falta
                                </el-button>
                            </td>
                            <td style="width: 125px;">
                                <el-button @click="alunos[indexAlunoSelected].horarios[horario].v = 'fj'" v-bind:class="{ reprovado: (alunos[indexAlunoSelected].horarios[horario].v == 'fj' ? true : false) }" :title="`Lançar presença no ${horario}º horário`" size="mini" style="width: 120px;" plain>
                                    Falta Justificada
                                </el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <el-form class="freq-observacao">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Observações" prop="texto" key="texto">
                                <el-input class="u-mt-10" :rows="10" type="textarea" v-model="alunos[indexAlunoSelected].observacao"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row :gutter="10">
                    <div class="u-text-right ">
                        <el-button type="primary" @click="fecharModalEditarFrequencia()">SALVAR</el-button>
                    </div>
                </el-row>
            </div>
        </el-dialog>

    </div>
</template>
<script>

export default {
    props: ['turmaSelected', 'dataSelected', 'horariosSelected'],
    data: () => ({
        showCardAcoes: false,
        dialogEditarFrequencia: false,
        loading: true,
        alunos: [],
        indexAlunoSelected: ''
    }),
    mounted () {        
        this.getAlunosByFrequencia();
    },
    methods:{
        async getAlunosByFrequencia(){
                        
            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/getAlunosByFrequencia`, {turma_id: this.turmaSelected.id, data: this.dataSelected}, this.$store.getters.getHeaderAuth);
            this.alunos = JSON.parse(JSON.stringify(response.data));

            for(let i in this.alunos){
                this.alunos[i] = this.defineFlag(this.alunos[i]);                
            }
            
            this.loading = false;
        },
        abreModalAlteraFrequencia(i){

            this.indexAlunoSelected = i;
            this.dialogEditarFrequencia = true;
        },
        fecharModalEditarFrequencia(){

            this.alunos[this.indexAlunoSelected] = this.defineFlag(this.alunos[this.indexAlunoSelected]);
            this.dialogEditarFrequencia = false;           
        },
        alteraFrequencia(i){

            this.indexAlunoSelected = i;

            let refValor = 'none';
            for(let j in this.horariosSelected){

                if(refValor == 'none'){
                    refValor = this.alunos[i].horarios[this.horariosSelected[j]].v;
                }
                if(refValor != this.alunos[i].horarios[this.horariosSelected[j]].v){
                    this.dialogEditarFrequencia = true;
                    return;
                }
            }

            for(let j in this.horariosSelected){

                if(this.alunos[i].horarios[this.horariosSelected[j]].v == ""){
                    this.alunos[i].horarios[this.horariosSelected[j]].v = 'p';
                }else if(this.alunos[i].horarios[this.horariosSelected[j]].v == 'p'){
                    this.alunos[i].horarios[this.horariosSelected[j]].v = 'f';
                }else if(this.alunos[i].horarios[this.horariosSelected[j]].v == 'f'){
                    this.alunos[i].horarios[this.horariosSelected[j]].v = 'p';
                }
            }

            this.alunos[i] = this.defineFlag(this.alunos[i]);
        }, 
        defineFlag(aluno){

            let flag = '';
            for(let j in this.horariosSelected){

                if(flag == ''){
            
                    if(aluno.horarios[this.horariosSelected[j]].v == ''){
                        flag = 0;
                    }else if(aluno.horarios[this.horariosSelected[j]].v == 'p'){
                        flag = 1;
                    }else if(aluno.horarios[this.horariosSelected[j]].v == 'f' || aluno.horarios[this.horariosSelected[j]].v == 'fj'){
                        flag = 2;
                    }

                }else{

                    if( flag != 3 &&
                        (
                            aluno.horarios[this.horariosSelected[j]].v == 'p' && flag == 2 || 
                            (aluno.horarios[this.horariosSelected[j]].v == 'f' || aluno.horarios[this.horariosSelected[j]].v == 'fj') && flag == 1
                        )
                    ){
                        flag = 3;
                    }
                }                
            }

            this.$set(aluno, 'flag', flag);

            return aluno;
        },
        notaCadastrada(){
            this.$emit('notaCadastrada', this.alunos);
        }        
    }
}
</script>
<style>
    .aprovado {
        background-color: #37ee5f !important;
    }
    .reprovado {
        background-color: #ff9595 !important;
    }
    .divergente {
        background-color: #f0ff9b !important;
    }
    .lista-smge {
        max-width: 100%;
        margin: 0 auto;
        z-index: 1;
    }
    .lista-smge ul {
        list-style: none;
        padding-left: 0px;
    }
    .lista-smge li:not(:first-child) {
        color: #404040;
        border-bottom: 1px solid #eaeaea;
        cursor: pointer;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .lista-smge li:first-child {
        padding: 10px;
        border-top: 1px solid #eaeaea;
        background-color: #f1f1f1;
    }
    .lista-smge h3 {
        margin: 0;
        font-weight: 400;
        color: #2d2d2d;
        font-size: 16px;
        letter-spacing: -.5px;
    }
    .lista-smge .freq-sub-titulo{
        font-weight: 300;
        color: #818181;
    }
    .lista-smge .box-data.list-alunos {
        padding-left: 10px;
        flex: 1;
    }
    .leg-freq {
        width: 22px;
        border: 1px solid;
        padding: 5px 10px;
        border-radius: 6px;
        background-color: #4f84b3;
        color: #fff;
        font-weight: bold;
        display: inline-block;
        text-align: center;
    }
    .freq-observacao {
        margin-top: 20px;
    }
    .freq-observacao .el-textarea__inner {
        border: 1px solid #989898 !important;
    }
    
</style>
